var pagination = {
	backwardText: "Previous page",
	forwardText: "Next page",
	pageRangeText: "{current} of {total} pages",
	itemsPerPageText: "Items per page",
	itemRangeText: "{start}-{end} of {total} items",
	pageNumberText: "Page number"
};
var searchPlaceholder = "Search...";
var enTranslations = {
	pagination: pagination,
	searchPlaceholder: searchPlaceholder
};

export { enTranslations as default, pagination, searchPlaceholder };
